import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';
// realtime user 用户页面
export const getUserTagData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/realtime/usertag',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getNightingaleUserTagData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/pc/inflexion/realtime/usertag',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getPcUserTagData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/pc/realtime/usertag',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

// realtime user 用户页面
export const geRetentionData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/realtime/retention',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const gePcRetentionData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/pc/realtime/retention',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

// realtime user revenue 页面
export const getRevenueData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/realtime/revenue_new',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getPcRevenueData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/pc/realtime/revenue_new',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getPcRealtimeSteamData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/pc/realtime/steam_trend',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getRevenueDataOld: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/realtime/revenue',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

// Realtime User - By Country/Region/Zone 页面
export const getRealtimeByCountryRegionZoneRetention: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/realtime/retention_d237',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getPcRealtimeByCountryRegionZoneRetention: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/pc/realtime/retention_d237',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getRealtimeByCountryRegionZoneNewActiveOnline: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/realtime/new_active_online',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getPcRealtimeByCountryRegionZoneNewActiveOnline: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/pc/realtime/new_active_online',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getNightingaleRealtimeActiveOnline: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/pc/inflexion/realtime/new_active_online',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

// Realtime User - ChangeAnalysis 页面
export const getRealtimeUserAnalysis: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/realtime/change/new_active_online',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getPcRealtimeUserAnalysis: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/pc/realtime/change/new_active_online',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getRealtimeUserAnalysisRetention: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/realtime/change/retention/d237',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getPcRealtimeUserAnalysisRetention: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/pc/realtime/change/retention/d237',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

// Realtime User - Data Download 页面
export const getDataDownloadUsers: (data: any, language: string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/realtime/overall/userinfo?language=${language}`,
        method: 'post',
        data: data,
        ignoreRequestId : false
    }
    return dashboardRequest(options)
};

export const getPcDataDownloadUsers: (data: any, language: string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/pc/realtime/overall/userinfo?language=${language}`,
        method: 'post',
        data: data,
        ignoreRequestId : false
    }
    return dashboardRequest(options)
};

export const getDataDownloadUsersDownload: (data: any, language: string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/realtime/overall/userinfo/download?language=${language}`,
        method: 'post',
        data: data,
        responseType: 'arraybuffer',
        rawData: true,
    }
    return dashboardRequest(options)
};

export const getPcDataDownloadUsersDownload: (data: any, language: string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/pc/realtime/overall/userinfo/download?language=${language}`,
        method: 'post',
        data: data,
        responseType: 'arraybuffer',
        rawData: true,
    }
    return dashboardRequest(options)
};

export const getDataDownloadRetention: (data: any, language: string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/realtime/overall/d237?language=${language}`,
        method: 'post',
        data: data,
        ignoreRequestId : false
    }
    return dashboardRequest(options)
};

export const getPcDataDownloadRetention: (data: any, language: string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/pc/realtime/overall/d237?language=${language}`,
        method: 'post',
        data: data,
        ignoreRequestId : false
    }
    return dashboardRequest(options)
};

export const getDataDownloadRetentionDownload: (data: any, language: string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/realtime/overall/d237/download?language=${language}`,
        method: 'post',
        data: data,
        responseType: 'arraybuffer',
        rawData: true,
    }
    return dashboardRequest(options)
};

export const getPcDataDownloadRetentionDownload: (data: any, language: string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/pc/realtime/overall/d237/download?language=${language}`,
        method: 'post',
        data: data,
        responseType: 'arraybuffer',
        rawData: true,
    }
    return dashboardRequest(options)
};


export const getRealtimeEventTypeList: (data:any) => Promise<any> = (data) => {
    const options = {
        url: `/api/v1/dashboard/event_analysis/realtime/date_event_list`,
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};